// extracted by mini-css-extract-plugin
export default {"header":"OnboardingPage_header__KHMwJ","wrapper":"OnboardingPage_wrapper__UD8pX"};